export default "__VITE_ASSET__nZPlMtOS__"